import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";


export const StudentStoryDetails = () => {
  const [isContentVisible, setIsContentVisible] = useState(null);
  useEffect(() => {
    AOS.init();
  }, []);

  // Static stories array
 const studentStoriesList = [
  
    
    {
      title: "Anushiya's Story: Crafting Spaces with Passion and Purpose",
      student_name: "Anushiya",
      date: "2023-11-22",
      description: "B.Arch 3rd Year Student",
      image: "",
      video: "https://www.youtube.com/watch?v=pvaHGfIwZqg"
    },
    {
      title: "Chalsie's Experience: Embracing Creativity and Community at McGAN'S",
      student_name: "Chalsie",
      date: "2022-08-15",
      description: "B.Arch 4th Year Student",
      image: "",
      video: "https://youtu.be/ntb9UCysfeg?si=36QRzuPaYBOqFDSV"
    },
    {
      title: "Harshith's Path: From First-Year Enthusiast to Future Architect",
      student_name: "Harshith",
      date: "2022-08-15",
      description: "B.Arch 1st Year Student",
      image: "",
      video: "https://www.youtube.com/watch?v=s6vdWqF0wks"
    },
    {
      title: "Kyati's Journey: Exploring Architecture at McGAN'S",
      student_name: "Kyati Golchha",
      date: "2022-08-15",
      description: "B.Arch 2nd Year Student",
      image: "",
       video: "https://www.youtube.com/watch?v=goJDHXfQsTU&list=PLFsYBPydyZDq5heF5sT6GfYc8-Ewyzw7W"
    },
    // Add more static stories as needed
  ];
function getYouTubeID(url) {
  const regExp =
    /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[1].length === 11 ? match[1] : null;
}


  const toggleContent = (index) => {
    setIsContentVisible((prevIndex) => (prevIndex === index ? null : index));
  };

  // Function to check if description is more than 20 words
  const isDescriptionLong = (description) => {
    return description.split(" ").length > 20;
  };

  // Function to get truncated description
  const getTruncatedDescription = (description) => {
    return description.split(" ").slice(0, 20).join(" ") + "...";
  };

  return (
    <>
      {/* Add SEO Tags */}
      <div>
        <Helmet>
          <title>
            Student Success Stories at McGAN'S Ooty School of Architecture |
            Inspiring Journeys in Architecture
          </title>
          <meta
            name="description"
            content="Explore inspiring success stories of McGAN'S Ooty School of Architecture students. Discover how our students overcome challenges, secure internships, and achieve remarkable milestones in architecture education."
          />
          <meta
            name="keywords"
            content="Student stories McGAN'S Ooty, 
Architecture student success stories, 
Inspiring architecture students Tamil Nadu, 
McGAN'S Ooty student achievements, 
Real-world experience architecture, 
Student internship success, 
McGAN'S Ooty student testimonials"
          />
          <meta property="og:title" content="Page Title" />
          <meta
            property="og:description"
            content="This is the page description for Open Graph"
          />
          <meta property="og:image" content="https://mcgansarch.com/" />
          <link
            rel="canonical"
            href="https://mcgansarch.com/student-story-details"
          />
        </Helmet>
        <h1 style={{ display: "none" }}>
          Inspiring Student Success Stories at McGAN'S Ooty School of
          Architecture
        </h1>
      </div>
      <div>
        {/* Start Page Banner */}
        <div className="page-banner-area bg-1">
          <div className="container">
            <div className="page-banner-content">
              <h3 className="BannerHeader">Student Story</h3>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="navspace">Student Story</li>
              </ul>
            </div>
          </div>
        </div>
        {/* End Page Banner */}

        {/* Start Campus Information */}
        <div class="health-care-area pt-70 pb-70">
          <div class="container">
            <div class="row justify-content-center">
              <h2 className="CarrersDetails1">
                Inspiring Journeys: Student Success Stories
              </h2>
              <p>
                Meet our students who turned ambition into achievement. From
                overcoming obstacles to reaching their goals, each story is a
                powerful testament to resilience and determination.
              </p>
              {studentStoriesList.map((storyDetails, index) => (
                <div className="story-card" key={index}>
                  <div className="student-photo">
                    {storyDetails.video && storyDetails.video !== "null" && storyDetails.video !== "" ? (
                      
                      // <video
                      //   width="150"
                      //   height="150"
                      //   controls
                      //   style={{ objectFit: "cover", borderRadius: "8px" }}
                      //   title="Student Story Video"
                      //   autoPlay
                      //       muted
                      // >
                      //   <source src={storyDetails.video} type="video/mp4" />
                      //   Your browser does not support the video tag.
                      // </video>
                       <iframe
  width="150"
  height="150"
  src={`https://www.youtube.com/embed/${getYouTubeID(storyDetails.video)}?autoplay=1&mute=1&loop=1&playlist=${getYouTubeID(storyDetails.video)}`}
  title="Student Story Video"
  frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowFullScreen
   referrerpolicy="strict-origin-when-cross-origin"
></iframe>
                    ) : (
                      <img
                        src={storyDetails.image}
                        width={150}
                        height={150}
                        title="Student stories McGAN'S Ooty"
                        alt="Student stories McGAN'S Ooty"
                      />
                    )}
                  </div>
                  <div className="student-details">
                    <h2>{storyDetails.student_name}</h2>
                    <h4 style={{ color: "#222" }}>
                      {new Date(storyDetails.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </h4>
                    {/* Display truncated or full description based on content visibility */}
                    <div className="additional-content studentstory">
                      <p className="text-justify ">
                        {isContentVisible === index ||
                        !isDescriptionLong(storyDetails.description)
                          ? storyDetails.description
                          : getTruncatedDescription(storyDetails.description)}
                      </p>
                    </div>
                    {/* Button to toggle content visibility */}
                    {isDescriptionLong(storyDetails.description) && (
                      <button
                        className="read-more-btn"
                        onClick={() => toggleContent(index)}
                        style={{
                          background: "none",
                          border: "none",
                          padding: "0",
                          cursor: "pointer",
                        }}
                      >
                        {isContentVisible === index ? "Read Less" : "Read More"}
                        <i className="flaticon-next"></i>
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
